export const contactsData = {
    email: 'iam@kaikubad.com',
    phone: '+8801814151802',
    address: 'Mirpur, Dhaka Bangladesh - 1216',

    sheetAPI: ''
}